export const roundNumberWithDecimal = (num: number, decimalPlaces: number): number => {
    const factor = 10 ** Math.abs(decimalPlaces);
    return Math.round(num * factor) / factor;
};

export const getPriceDecimal = (totalAmount: number, minPriceForRounding: number): number => {
    if (totalAmount > minPriceForRounding) {
        return 0;
    }
    return 1;
};
